class NfeOperations {
    constructor(scope, modal, attrs) {
        this.scope = scope
        this.modal = modal
        this.hasVoltar = !!attrs.onVoltar
    }

    openImportModal(zip = false) {
        this.modal.open({
            backdrop: 'static',
            component: 'nfeUploadModal',
            resolve: {
                emissaoPropria: () => this.emissaoPropria,
                contratoId: () => this.contratoId,
                zip: zip
            }
        })
    }

    openDashboardNumeracaoModal() {        
        this.modal.open({
            component: 'nfeDashboardNumeracaoModal',
            backdrop: 'static',
            size: 'xl',
            resolve: {
                empresaId: () => this.contratoId
            }
        })
    }

    openColetoresHistoricosModal() {
        this.modal.open({
            component: 'coletoresHistoricosModal',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                contratoId: () => this.contratoId
            }
        })
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeOperations', {
        controller: ['$scope', '$uibModal', '$attrs', NfeOperations],
        bindings: {
            onVoltar: '&',
            contratoId: '<',
            emissaoPropria: '<',
            isFeatureNumeracoesAusentesEnabled: '<',
            disabled: '<'
        },
        template: `
        <operations-toolbar>
            <left ng-if="$ctrl.hasVoltar">
                <button class="btn btn-default" ng-click="$ctrl.onVoltar()">
                    <i class="fa fa-arrow-left"></i> Voltar
                </button>
            </left>
            <right>
                <button class="btn btn-default"
                        ng-click="$ctrl.openImportModal()"
                        ng-disabled="$ctrl.disabled">
                    <i class="fa fa-upload"></i>
                    Enviar XML
                </button>
                <button class="btn btn-default"
                        ng-click="$ctrl.openImportModal(true)"
                        ng-disabled="$ctrl.disabled">
                    <i class="fa fa-upload"></i>
                    Enviar ZIP de XMLs
                </button>
                <a 
                    href="http://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&tipoConteudo=XbSeqxE8pl8=" 
                    target="_blank" 
                    class="btn btn-default" 
                    style="margin: 5px"
                    ng-disabled="$ctrl.disabled">
                    <i class="fa fa-link"></i> Portal da NF-e
                </a>
                <button 
                    class="btn btn-default" 
                    ng-click="$ctrl.openDashboardNumeracaoModal()" 
                    ng-if="$ctrl.isFeatureNumeracoesAusentesEnabled"
                    ng-disabled="$ctrl.disabled">
                    <i class="fa fa-tachometer"></i> Dashboard de numeração
                </button>
                <button 
                    class="btn btn-default" 
                    ng-click="$ctrl.openColetoresHistoricosModal()"
                    ng-disabled="$ctrl.disabled">
                    <i class="fa fa-desktop"></i> Histórico dos coletores
                </button>
            </right>
        </operations-toolbar>
        `
    })
